import script from "./TeamCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamCard.vue?vue&type=script&setup=true&lang=js"

import "./TeamCard.vue?vue&type=style&index=0&id=4b3c8794&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b3c8794"]])

export default __exports__